import React from 'react';
import { ImagesWrapper } from '@@Components/ImagesBanner/styled';
export const ImagesBanner = ({ items = [
    { path: './assets/imagesBannerImages/Foto1.jpg' },
    { path: './assets/imagesBannerImages/Foto2.jpg' }
] }) => {
    if (!items || !(items instanceof Array) || !items.length || items.length < 2)
        return null;
    const addLink = (component, link) => {
        if (link === null || link === void 0 ? void 0 : link.url) {
            return React.createElement("a", { href: link.url, target: link.target, title: link.label, className: 'item' }, component);
        }
        return component;
    };
    return React.createElement(ImagesWrapper, null, items.slice(0, 2).map(item => addLink(React.createElement("img", { alt: (item === null || item === void 0 ? void 0 : item.title) || undefined, title: (item === null || item === void 0 ? void 0 : item.title) || undefined, src: item === null || item === void 0 ? void 0 : item.path, className: "item", 
        // @ts-ignore
        loading: "lazy" }), item === null || item === void 0 ? void 0 : item.link)));
};
